import * as React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

import styles from './Loader.module.css';
import { useTranslation } from 'react-i18next';

export const Loader = () => {
  const { t } = useTranslation();

  return (
    <div className={styles['container']}>
      <div className={styles['loader']}>
        <DotLottieReact src="/static/animations/three-dots.lottie" loop autoplay themeId="blue" />
      </div>
      {t('Thinking')}
    </div>
  );
};
